import { useGeneralStore } from "%/stores/general-store";

export function getUserProfileHref(userId) {
  const generalStore = useGeneralStore();

  if (generalStore.appId === 1) {
    return `${generalStore.webUrl}/community/org/${userId}/profile`;
  }

  return `${generalStore.fanUrl}/user-profile/${userId}`;
}

export function getUserDirectMessageHref(userId) {
  const generalStore = useGeneralStore();

  if (generalStore.appId === 1) {
    return `${generalStore.webUrl}/community/user/${userId}/message`;
  }

  return `${generalStore.fanUrl}/chat-room?entity_id=${userId}&context=direct_messaging`;
}
